import { render, staticRenderFns } from "./CultivationTable.vue?vue&type=template&id=e93d0530&scoped=true&"
import script from "./CultivationTable.vue?vue&type=script&lang=js&"
export * from "./CultivationTable.vue?vue&type=script&lang=js&"
import style0 from "./CultivationTable.vue?vue&type=style&index=0&id=e93d0530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93d0530",
  null
  
)

export default component.exports